@if (state$ | async) {
    <ul class="sh-form-check-list" [id]="id" [ngClass]="{ '-sh-inline': inline }">
        @for (item of items; track item; let i = $index) {
            <li class="sh-form-check sh-form-check-list__item" [title]="item | getDisabledMsg: disabledMsg">
                <!-- Both name and attr.name should be set on radio buttons, see https://github.com/angular/angular/issues/11757 -->
                <input
                    #radioButtons
                    type="radio"
                    [formControl]="control"
                    [id]="groupName + '-option-' + item.id"
                    [value]="item.value"
                    [name]="groupName"
                    [attr.name]="groupName"
                    class="sh-radio sh-form-check__input sh-form-group__input"
                    [attr.aria-describedBy]="invalid ? describeLabelId : null"
                    [attr.aria-invalid]="invalid"
                    [attr.data-indeterminate]="isIndeterminate($any(item.value)) ? true : null"
                    [attr.disabled]="disabled || $any(item)?.disabled ? true : null"
                />
                <label [for]="groupName + '-option-' + item.id" class="sh-form-check__label">{{ item.label }}</label>
            </li>
        }
    </ul>
}
